import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import { Header, Footer, HeaderParagraph, Input, Icon, Button, FlexContainer, MobileFooter } from '../components'
const TopWrapper = styled.div`
  max-width: 1366px;
  margin: 0 auto;
  @media (max-width: 768px) {
    padding: 40px 16px 20px;
    & > h1 {
      font-size: 28px !important;
      line-height: normal !important;
      letter-spacing: normal !important;
    }
    & > p {
      font-size: 16px !important;
      font-weight: 300 !important;
      line-height: 1.38 !important;
      letter-spacing: 0.1px !important;
    }
  }
  @media (max-width: 640px) {
    padding-left: 10px;
    padding-right: 10px;
  }
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 80px 250px 60px 80px;
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  & > p {
    text-align: left;
    padding: 0;
    padding-top: 10px;
    font-size: 18px;
    font-weight: 300;
    line-height: 1.61;
  }
  & > h1 {
    font-size: 48px;
    line-height: 1.27;
    color: #333333;
  }
`

const BodyWrapper = styled.div`
  & > footer:first-child {
    @media (max-width: 992px) {
      display: none;
    }
  }
  & > footer:last-child {
    display: none;
    @media (max-width: 992px) {
      display: block;
    }
  }
`
const ContactFrom = styled.div`
  margin-top: 50px;
`
const FromGroup = styled.div`
  width: 100%;
  margin-right: 20px;
  margin: 8px;
  input,
  textarea {
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    width: 100%;
  }
  input {
  }
  textarea {
    padding: 10px;
    min-height: 150px;
    :focus {
      box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
      outline: none;
    }
  }
`
const AddressWrap = styled.div`
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  margin-top: 20px;
  margin-left: 30px;

  @media (max-width: 768px) {
    margin-left: 0px;
  }
`
const AddressContent = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 0;
  a {
    color: #000;
  }
  > span {
    margin-right: 10px;
  }
  p {
    font-size: 14px;
    color: #555;
    font-weight: 500;
    margin-bottom: 5px;
  }
  p span {
    font-weight: bold;
    display: block;
    font-size: 16px;
    color: #000;
  }
`
class Contact extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email:
        this.props.location && this.props.location.search
          ? decodeURIComponent(this.props.location.search.split('=')[1])
          : ''
    }

    this.handleChange = this.handleChange.bind(this)
  }
  handleChange(event) {
    this.setState({ email: event.target.value })
  }
  render() {
    console.log('this.props', this.props.location.search.split('=')[1])

    return (
      <React.Fragment>
        <Header />
        <TopWrapper>
          <HeaderParagraph
            headerColor={'#333333'}
            headerFontSize={'38px'}
            header={'Contact'}
            paragraph={'Sent us a message'}
          />

          <FlexContainer>
            <ContactFrom>
              <form action="https://formspree.io/harsh@8om.io" method="POST">
                <FlexContainer>
                  <FromGroup>
                    <Input type="name" icon="user" name="Name" placeholder="Name" changeColor={'#35cc62'} required />
                  </FromGroup>
                  <FromGroup>
                    <Input
                      type="email"
                      name="_replyto"
                      icon="email"
                      placeholder="Email"
                      changeColor={'#35cc62'}
                      onChange={this.handleChange}
                      value={this.state.email}
                      required
                    />
                  </FromGroup>
                </FlexContainer>
                <FlexContainer>
                  <FromGroup>
                    <Input
                      type="phone"
                      name="contact"
                      icon="contact"
                      placeholder="Phone"
                      changeColor={'#35cc62'}
                      required
                    />
                  </FromGroup>
                </FlexContainer>
                <FlexContainer>
                  <FromGroup>
                    <textarea name="textarea" id="" placeholder="Your message type here" />
                  </FromGroup>
                </FlexContainer>
                <input type="hidden" name="_next" value="/" />
                <FromGroup>
                  <Button type="submit" title="Submit" />
                </FromGroup>
              </form>
            </ContactFrom>

            <AddressWrap>
              <AddressContent>
                <span>
                  <Icon icon="contact" />
                </span>
                <p>
                  Phone
                  <span>
                    <a href="tel:+918076157787"> +91 8076157787</a>
                  </span>
                </p>
              </AddressContent>
              <AddressContent>
                <span>
                  <Icon icon="email" />
                </span>
                <p>
                  Email
                  <span>
                    <a href="mailto:harsh@8om.io"> harsh@8om.io</a>
                  </span>
                </p>
              </AddressContent>
              <AddressContent>
                <span>
                  <Icon icon="website" />
                </span>
                <p>
                  Website
                  <span>8om.io</span>
                </p>
              </AddressContent>
              <AddressContent>
                <span>
                  <Icon icon="location" />
                </span>
                <p>
                  Location
                  <span>
                    3rd Floor, Plot No. 8 Balaji Estate,
                    <br /> Guru Ravidas Marg, Kalkaji,
                    <br /> New Delhi, Delhi 110019
                  </span>
                </p>
              </AddressContent>
            </AddressWrap>
          </FlexContainer>
        </TopWrapper>
        <BodyWrapper>
          <Footer />
          <MobileFooter />
        </BodyWrapper>
      </React.Fragment>
    )
  }
}

export default withRouter(Contact)



// WEBPACK FOOTER //
// ./src/pages/Contact.js